import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
export default function Health() {
  useLanguage();
  return (
    <div style={{ 
      padding: '20px', 
      fontFamily: 'monospace',
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    }}>
      <div>{translateInterfaceText("✅ Status: OK")}</div>
      <div>{translateInterfaceText("🕐 Timestamp:")}{" "}{new Date().toISOString()}</div>
      <div>{translateInterfaceText("🌐 Environment:")}{" "}{import.meta.env.MODE}</div>
    </div>
  );
}
